//@ts-nocheck
import "./style.css";
import L from "leaflet";
import clsx from "clsx";
import Atom from "../atom";
import "leaflet/dist/leaflet.css";
import defaultIcon from "./places.png";
import React, { useEffect, useState, useRef } from "react";
import { Marker, Popup, TileLayer, MapContainer, useMap } from "react-leaflet";

const IconMarker = (iconName, markerIcon, text) => {
  let iconHtml = `<div class="position-relative"><img src="${
    markerIcon || defaultIcon
  }" alt="" class="iconImg"/>`;
  if (text) {
    iconHtml = iconHtml + `${text}</div>`;
  } else if (iconName) {
    iconHtml = iconHtml + `<i class="fa fa-${iconName} iconOnMapMarker"></i>`;
  } else {
    iconHtml = iconHtml + `</div>`;
  }
  return iconHtml;
};

type leafletProps = {
  center: Array;
  zoom: number;
  height: string;
  width: string;
  markers: { position: Array; content: any };
};

function MyComponent({ getMap }) {
  const map = useMap();
  getMap?.(map);
  return null;
}

export default function LeafletMap(props: leafletProps) {
  const {
    getMap,
    center,
    markers,
    zoom = 13,
    className,
    myLocation,
    height = "100%",
    width = "100%",
    ...other
  } = props;

  const [map, setMap] = useState();
  const [location, setLocation] = useState();

  const mapRef = useRef(null);
  // const map = useMap();

  useEffect(() => {
    getLocation();
    
  }, []);

  useEffect(() => {
    if (map) {
      getMap?.(map);
    }
    
  }, [map]);

  const getLocation = () => {
    const def = [];
    if (!navigator.geolocation) {
      setLocation(def);
    } else {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position?.coords?.latitude;
          const lng = position?.coords?.longitude;
          setLocation([lat, lng]);
        },
        () => {
          setLocation(def);
        },
        { timeout: 2000 }
      );
    }
  };

  const moveToUserLocation = () => {
    if (map) {
      map?.flyTo(location);
    }
  };

  const getMapHook = (mp) => {
    setMap(mp);
  };

  return (
    <Atom.Div style={{ width, height }} className="position-relative">
      <MapContainer
        {...other}
        ref={mapRef}
        zoom={zoom}
        center={center}
        style={{ height, width }}
        className={clsx("GLeafletMap hideScroll", className)}
      >
        <MyComponent getMap={getMapHook} />
        <TileLayer url="https://cloud.gandom.org/map/tileset/Gandom-streets/512/{z}/{x}/{y}.png" />

        {markers?.length
          ? markers.map((item, index) => (
              <Marker
                position={item.position}
                key={index}
                icon={L.divIcon({
                  html: IconMarker(),
                  // itemMarker.name,
                  // itemMarker.icon,
                  // itemMarker.text,
                  // itemMarker.image
                })}
              >
                {item.content && <Popup>{item.content}</Popup>}
              </Marker>
            ))
          : null}
      </MapContainer>
      <Atom.Div className="position-absolute leafletMyLogo">
        <Atom.A href="https://geo.gandom.org" className="text-decoration-none">
          <Atom.Div className="d-flex logoWrapper">
            <Atom.Typography type="caption1" className="logoTxt">
              ©Gandom Map
            </Atom.Typography>
            <Atom.Img src="/logo128.png" alt="logo" />
          </Atom.Div>
        </Atom.A>
      </Atom.Div>

      {myLocation ? (
        <button className="myLocation" onClick={moveToUserLocation}>
          <i className="fa-solid fa-location-arrow" />
        </button>
      ) : null}
    </Atom.Div>
  );
}
